<template>
  <div>
    <vx-card class="mb-5" title="Learning & Resources">
      <h4 class="mb-5">Environmental Scientists</h4>

      <p class="mb-5">
        The environment provides us with everything humans need to exist, thrive, and survive.
      </p>
      <p class="mb-5">
        The environment is everything around us, and Environmental Science studies how humans
        interact with and rely on our environment.
      </p>

      <p class="mb-5">
        The below video is a great watch that will give you an overview in an interesting and
        comprehensive way.
      </p>
      <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" />
      <p class="mb-5">Click on the image below to view or download a few highlights.</p>

      <centered-image-wrapper
        :image="require('@/assets/images/experiences/envscience/overview_button.png')"
        classes="2/3"
        alt="Read the Environmental Science overview (PDF, opens in a new tab)"
        :link="'content/envscience/enviro_science_overview.pdf' | blob_url"
      />
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  data() {
    return {
      videos: {
        1: {
          video: 'https://www.youtube.com/embed/RoIpCJwX7-M',
          image: require('@/assets/images/experiences/envscience/l_r_video_1_splash.jpg'),
        },
      },
    };
  },
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
